import React from 'react';
import {Card, HorizontalBar} from './primitives';
import type {OhdResultSetCounts} from '../types';
import {SCREENING_MODALITY_COLORS} from './chart-colors';

interface Props {
    counts: OhdResultSetCounts;
}

const MODALITIES: Array<{key: keyof Omit<OhdResultSetCounts, 'total_results'>; label: string; color: string}> = [
    {key: 'lab', label: 'Lab', color: SCREENING_MODALITY_COLORS.lab},
    {key: 'physician', label: 'Physician', color: SCREENING_MODALITY_COLORS.physician},
    {key: 'home_test_kit', label: 'Home Test Kit', color: SCREENING_MODALITY_COLORS.home_test_kit},
    {key: 'onsite', label: 'Onsite Screening', color: SCREENING_MODALITY_COLORS.onsite},
];

const ScreeningModalityCard: React.FC<Props> = ({counts}) => {
    const total = counts.total_results || 1;
    return (
        <div>
            <h3 className="mb-2 text-[24px] text-mld-muted-text">Screening Modality</h3>
            <Card>
                <div className="flex h-[266px] flex-col justify-center space-y-3 px-5">
                    {MODALITIES.map((m) => {
                        const count = counts[m.key];
                        const pct = Math.round((count / total) * 100);
                        return (
                            <HorizontalBar
                                key={m.key}
                                pct={pct}
                                color={m.color}
                                label={m.label}
                                detail={`${count.toLocaleString()} (${pct}%)`}
                            />
                        );
                    })}
                </div>
            </Card>
        </div>
    );
};

export default ScreeningModalityCard;
